import script from "./GoogleSignin.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleSignin.vue?vue&type=script&setup=true&lang=js"

import "./GoogleSignin.vue?vue&type=style&index=0&id=5f09dc62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f09dc62"]])

export default __exports__